import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useApp } from "contexts/AppContext";
import AuthPage from "containers/LoginPage/AuthPage";
import VerifyUser from "containers/VerifyUser/VerifyUser";
import ProtectedRoute from "ProtectedRoute";
import RequireAuthVerifiedNotSubscribed from "RequireAuthVerifiedNotSubscribed";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import LoginForm from "containers/LoginPage/components/LoginForm";
import RegisterForm from "containers/LoginPage/components/RegisterForm";
import AcceptOrganizationInvitation from "containers/LoginPage/components/AcceptOrganizationInvitation";
import PasswordRecovery from "containers/LoginPage/components/PasswordRecovery";
import AuthCard from "containers/LoginPage/AuthCard";
import { CardContent } from "@mui/material";
import RequireGuest from "RquireGuest";
import Main from "containers/Main/Main";
import RequireSubscription from "RequireSubscription";
import RequireAuthButNotVerified from "RequireAuthButNotVerified";
import SubscriptionPageV2 from "containers/Subscription/SubsscriptionPageV2";

const Routing = () => {
  const { state } = useApp();

  // Wait until subscription state is fully loaded
  if (state.loading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      {/* PUBLIC */}
      <Route
        path="/auth"
        element={
          <RequireGuest isAuth={state.isAuth}>
            <AuthPage />
          </RequireGuest>
        }
      >
        <Route index element={<Navigate to="/auth/login" />} />
        <Route path="login" element={<LoginForm />} />
        <Route path="register" element={<RegisterForm />} />
        <Route
          path="accept-organization-invitation/:token"
          element={<AcceptOrganizationInvitation />}
        />
        <Route path="recover-password" element={<PasswordRecovery />} />
      </Route>
      {/* PROTECTED */}
      <Route
        path="/verify"
        element={
          <RequireAuthButNotVerified
            isAuth={state.isAuth}
            isVerified={state.isVerified}
          >
            <Box sx={{ padding: 2 }}>
              <AuthCard>
                <CardContent sx={{ minWidth: "xs", maxWidth: "xs" }}>
                  <VerifyUser />
                </CardContent>
              </AuthCard>
            </Box>
          </RequireAuthButNotVerified>
        }
      />
      {/* /subscription => must be logged in, verified, no active subscription */}
      <Route
        path="/subscriptionv2"
        element={
          <RequireAuthVerifiedNotSubscribed
            isAuth={state.isAuth}
            isVerified={state.isVerified}
            hasActiveSubscription={state.hasActiveSubscription}
          >
            <SubscriptionPageV2 />
          </RequireAuthVerifiedNotSubscribed>
        }
      />
      <Route
        path="/*"
        element={
          <RequireSubscription
            isAuth={state.isAuth}
            isVerified={state.isVerified}
            hasActiveSubscription={state.hasActiveSubscription}
          >
            <Main />
          </RequireSubscription>
        }
      />
      {/* <Route
        path="/*"
        // Redirect to app
        element={<Navigate to="/app" replace />}
      /> */}
    </Routes>
  );
};

export default Routing;
